module.exports = __webpack_public_path__ + "img/icone-servico.24bbcca2.svg";